import { Checkbox, FormControlLabel } from '@mui/material';
import { useTenant } from '../../../contexts/TenantContext';

/**
 * The marketing consent on both registration forms. Unticked until the guest ticks it: consent is
 * given only by doing so. The wording is recorded in docs/DECISIONS.md with the date it took effect,
 * because a guest's `marketing_consent_at` says which version they agreed to — change it only with
 * a new entry there.
 */
const MarketingConsentCheckbox = ({ checked, onChange }) => {
  const { tenant, displayConfig, homePage } = useTenant();
  const businessName = homePage?.businessName || tenant?.name;
  const accent = displayConfig?.primaryColor;

  return (
    <FormControlLabel
      control={
        <Checkbox
          id="marketingConsent"
          name="marketingConsent"
          checked={checked}
          onChange={onChange}
          data-testid="marketing-consent-checkbox"
          sx={{ color: displayConfig?.color, '&.Mui-checked': { color: accent } }}
        />
      }
      label={`Hozzájárulok, hogy a(z) ${businessName} akciókról és újdonságokról e-mailben tájékoztasson. Ezt bármikor visszavonhatom a profilomban.`}
      sx={{
        // As wide as the text fields above it, and the box beside the first line of the text.
        width: { xs: "100%", sm: "90%", md: "80%", lg: "70%", xl: "60%" },
        alignSelf: "center",
        alignItems: "flex-start",
        mx: 0,
        '& .MuiCheckbox-root': { pt: 0.25 },
        '& .MuiFormControlLabel-label': { fontSize: 12, color: displayConfig?.color },
      }}
    />
  );
};

export default MarketingConsentCheckbox;
